import React from 'react';
import { Link, graphql, StaticQuery } from 'gatsby';
import Img from 'gatsby-image';

import './footer.scss';
import Dropdown from '../dropdown/dropdown';

export default ({ location }) => (
  <StaticQuery
    query={graphql`
      query FooterQuery {
        logo: file(relativePath: { eq: "logo-white.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }

        services: allContentfulService {
          edges {
            node {
              name
              slug
            }
          }
        }
      }
    `}
    render={data => (
      <footer className="footer" id="contatti">
        <h4 className="footer__title">Contattaci</h4>
        <hr />
        <span className="footer__subtitle">Prenota la tua visita</span>

        <div className="footer__content">
          <div className="footer__content-address">
            <Img fluid={data.logo.childImageSharp.fluid} className="footer__logo"></Img>
            <div>
              <strong>Spazio 536 Studio estetico</strong>
            </div>
            <div>Via Jacopo Da Porto, 536</div>
            <div>Baggiovara (MO)</div>
          </div>

          <hr className="footer_hr" />

          <div className="footer__content-contacts">
            <input placeholder="Il tuo nome" />
            <input placeholder="Il tuo numero di telefono" />
            <input placeholder="La tua email" />
            <textarea placeholder="Aggiungi un messaggio" />
            <button>Invia</button>
          </div>
        </div>

        <div className="footer__footer">
          <span className="footer__footer-name">Spazio 536</span>

          <nav role="navigation">
            <Link className={location.pathname.includes('servizio') ? 'active' : ''}>
              <Dropdown
                position="top"
                activatorText="Servizi e trattamenti"
                items={data.services.edges.map(edge => ({
                  name: edge.node.name,
                  link: `/servizio/${edge.node.slug}`,
                }))}
              />
            </Link>
            <Link to="/about" className={location.pathname === '/about' ? 'active' : ''}>
              <strong>Dove siamo</strong>
            </Link>
            <Link to="/about" className={location.pathname === '/about' ? 'active' : ''}>
              <strong>Chi siamo</strong>
            </Link>
            <Link to="/about" className={location.pathname === '/about' ? 'active' : ''}>
              <strong>Contatti</strong>
            </Link>
          </nav>

          <div className="footer__footer-social"></div>
        </div>
      </footer>
    )}
  ></StaticQuery>
);
